import stratifyVar from '../refs/stratifyVar';

const calculateCorrelation = require("calculate-correlation")

var pcorrtest = require( '@stdlib/stats-pcorrtest' );

export default function scatterplot({
    divId,
    trackA,
    trackB,
    useZscore,
    wholeTrackData,
    cohortSelected,
    studySelected
}) {
    const divCurrentWidth = document.getElementById(divId).offsetWidth

    const Plotly = window.Plotly

    if (!trackA || !trackB) { return }

    console.log('scatterplot.js wholeTrackData', wholeTrackData)


    let idsInCohortSelected = Object.keys(wholeTrackData.cohort.data).filter( k => cohortSelected.includes(wholeTrackData.cohort.data[k]))
    console.log('scatterplot.js idsInCohortSelected', idsInCohortSelected)
    let title_cohort_text = 'both discovery and validation cohorts'
    if (cohortSelected.length < 2) {
        title_cohort_text = `the ${cohortSelected[0]} cohort`
    }
    let trackC = trackA.responseCohort
    let trackD = trackB.responseCohort

    let trackE = trackA.nonResponseCohort
    let trackF = trackB.nonResponseCohort

    console.log('scatterplot.js trackA', trackA)
    console.log('scatterplot.js trackB', trackB)
    console.log('scatterplot.js trackC', trackC)
    console.log('scatterplot.js trackD', trackD)
    console.log('scatterplot.js trackE', trackE)
    console.log('scatterplot.js trackF', trackF)

    
    var corr_data_whole = track_to_lines(trackA, trackB, idsInCohortSelected)
    console.log('scatterplot.js corr_data_whole', corr_data_whole)
    var linetrace = create_fitted_line_trace(corr_data_whole.non_na_x, 
                                            corr_data_whole.non_na_y, 
                                            '#7FC2D9', 
                                    `Best fit line of all partipants in the selected cohort(s) <br />(Corr:${corr_data_whole.corr}, p-val: ${corr_data_whole.pv})`)
    
    console.log('scatterplot.js linetrace', linetrace)                        
    var corr_data_response = track_to_lines(trackC, trackD, idsInCohortSelected)
    var linetraceT = create_fitted_line_trace(corr_data_response.non_na_x, 
        corr_data_response.non_na_y, '#005AB5', 
        `Best fit line of all participants with ${stratifyVar[studySelected].class1_name} <br />(Corr:${corr_data_response.corr}, , p-val: ${corr_data_response.pv})`)

    console.log('scatterplot.js corr_data_response', corr_data_response)
    // const samplesN = Object.keys(trackE.data).filter(s => s in trackF.data)

    // const se = samplesN.map(sample => trackE.data[sample])
    // const sf = samplesN.map(sample => trackF.data[sample])

    // var non_nan_xyN = filter_non_nan_xy(se, sf)
    // const non_na_xN = non_nan_xyN.x
    // const non_na_yN = non_nan_xyN.y
    var corr_data_NR = track_to_lines(trackE, trackF, idsInCohortSelected)
    var linetraceN = create_fitted_line_trace(corr_data_NR.non_na_x, corr_data_NR.non_na_y, 
        '#DC3220', `Best fit line of all participants with ${stratifyVar[studySelected].class2_name}<br />(Corr:${corr_data_NR.corr}, p-val: ${corr_data_NR.pv})`)
                                
    // const samples = Object.keys(trackA.data).filter(s => s in trackB.data)
    console.log('scatterplot.js corr_data_NR', corr_data_NR)
    var trace2 = {
        x: corr_data_response.x,
        y: corr_data_response.y,
        mode: 'markers',
        type: 'scatter',
        name: `${stratifyVar[studySelected].class1_name} Cohort`,
        marker: { size: 10, color: '#005AB5' },
        // text: samplesT
        // color: 'red'
    }

    console.log('scatterplot.js trace2', trace2)

    var trace3 = {
        x: corr_data_NR.x,
        y: corr_data_NR.y,
        mode: 'markers',
        type: 'scatter',
        name: `${stratifyVar[studySelected].class2_name} Cohort`,
        marker: { size: 10 , color: '#DC3220'},
        // text: samplesN
        // color: 'green'
    }

    // const x = samples.map(sample => trackA.data[sample])
    // const y = samples.map(sample => trackB.data[sample])

    // const correlation = calculateCorrelation(x, y)

    // var trace1 = {
    //     x,
    //     y,
    //     mode: 'markers',
    //     type: 'scatter',
    //     name: 'Team A',
    //     marker: { size: 12 }
    // }

    const suffixes = {
        'CNV': 'log2 ratio',
        'RNA': 'log TPM',
        'Proteo': 'log2 intensity',
        'CellType': 'Portion',
        'Kinase': 'z-score', 
        'TranscriptionFactor': 'z-score', 
        'ubiq': 'z-score', 
        'glyco': 'z-score', 
        'phospho': 'z-score',
        'Mutation': '0: Wildtype, 1: Mutation'
    }
    
    // add # of samples
    var data = [linetraceT, linetraceN, linetrace, trace2, trace3];
    
    

    const xTitle = useZscore ? `${trackA.title} (zscore)` : `${trackA.title} (${suffixes[trackA.dataType]})`
    const yTitle = useZscore ? `${trackB.title} (zscore)` : `${trackB.title} (${suffixes[trackB.dataType]})`
    // const xTitle = useZscore ? `${trackA.title} (zscore)` : `${trackA.title}`
    // const yTitle = useZscore ? `${trackB.title} (zscore)` : `${trackB.title}`

    var layout = {
        // title: `${trackA.title} - ${trackB.title}<br>pearson correlation: ${correlation}`,
        title: `${trackA.title} vs ${trackB.title} <br>(${title_cohort_text})`,
        xaxis: {
            title: xTitle,
            hoverformat: '.2f',
            autorange: false,
            range: corr_data_whole.x_range
            // scaleanchor: "y",
            // scaleratio: 1,
        },
        yaxis: {
            title: yTitle,
            hoverformat: '.2f',
            autorange: false,
            range: corr_data_whole.y_range
            // scaleanchor: "x",
            // scaleratio: 1,
        },
        scene: {
            aspectratio: {
              x: 1,
              y: 10,
              z: 1
            }
          },
        width: divCurrentWidth,
        height: divCurrentWidth*0.8,
        // legend: {
        //     y: 0.5,
        //     yref: 'paper',
        //     font: {
        //       family: 'Arial, sans-serif',
        //       size: 20,
        //       color: 'grey',
        //     }
        //   },
    };
      
    Plotly.newPlot(divId, data, layout);
}

function intersect(o1, o2){
    return Object.keys(o1).filter(k => Object.hasOwn(o2, k))
}

function linearRegression(x,y){
    var lr = {};
    var n = y.length;
    var sum_x = 0;
    var sum_y = 0;
    var sum_xy = 0;
    var sum_xx = 0;
    var sum_yy = 0;

    for (var i = 0; i < y.length; i++) {

        sum_x += x[i];
        sum_y += y[i];
        sum_xy += (x[i]*y[i]);
        sum_xx += (x[i]*x[i]);
        sum_yy += (y[i]*y[i]);
    } 

    lr['sl'] = (n * sum_xy - sum_x * sum_y) / (n*sum_xx - sum_x * sum_x);
    lr['off'] = (sum_y - lr.sl * sum_x)/n;
    lr['r2'] = Math.pow((n*sum_xy - sum_x*sum_y)/Math.sqrt((n*sum_xx-sum_x*sum_x)*(n*sum_yy-sum_y*sum_y)),2);

    return lr;
}

function create_fitted_line_trace(_x, _y, _color, _des) {
    var fit_from = Math.min(..._x)
    var fit_to = Math.max(..._x)
    var lr = linearRegression(_x, _y);
    var fit = {
        x: [fit_from, fit_to],
        y: [fit_from*lr.sl+lr.off, fit_to*lr.sl+lr.off],
        mode: 'lines',
        type: 'scatter',
        line: {color: _color},
        name: _des
        // name: "R2=".concat((Math.round(lr.r2 * 10000) / 10000).toString())
        };
    return fit
}

function filter_non_nan_xy(_x, _y){
    var non_na_xidx = _x.map(i => i !== undefined)
    var non_na_yidx = _y.map(i => i !== undefined)

    var non_na_xyidx = non_na_xidx.map((e, i) => e & non_na_yidx[i])
    var _non_na_x = _x.filter((e, i) => non_na_xyidx[i])
    var _non_na_y = _y.filter((e, i) => non_na_xyidx[i])
    var non_nan_xy = {};
    non_nan_xy['x'] = _non_na_x
    non_nan_xy['y'] = _non_na_y
    return non_nan_xy
}

function track_to_lines(xTrack, yTrack, idsInCohortSelected_) {

    const samples_xy = Object.keys(yTrack.data).filter(s => Object.keys(xTrack.data).includes(s))
    const samples_ = samples_xy.filter(s => idsInCohortSelected_.includes(s))
    const x_ = samples_.map(sample => xTrack.data[sample])
    const y_ = samples_.map(sample => yTrack.data[sample])
    const x_wholeCohort = samples_xy.map(sample => xTrack.data[sample]).filter(Number.isFinite);
    const y_wholeCohort = samples_xy.map(sample => yTrack.data[sample]).filter(Number.isFinite);
    console.log('test scatter 1', x_wholeCohort, y_wholeCohort)
    const x_axis = Math.max(...x_wholeCohort)-Math.min(...x_wholeCohort)
    const y_axis = Math.max(...y_wholeCohort)-Math.min(...y_wholeCohort)
    const x_range = [Math.min(...x_wholeCohort)-0.05*x_axis, 
                    Math.max(...x_wholeCohort)+0.05*x_axis]
    const y_range = [Math.min(...y_wholeCohort)-0.05*y_axis, 
                    Math.max(...y_wholeCohort)+0.05*y_axis]
    // console.log('test scatter 7')
    // console.log(samples)
    // console.log(trackA)
    var non_nan_xy_ = filter_non_nan_xy(x_, y_)
    var non_na_x_ = non_nan_xy_.x
    var non_na_y_ = non_nan_xy_.y
    // console.log(non_na_x_)
    // console.log(non_na_y_)
    var corr_dict = pcorrtest(non_na_x_, non_na_y_)
    var correlation = corr_dict.pcorr
    var corr_pv = corr_dict.pValue
    console.log(non_na_x_)
    console.log(non_na_y_)
    var return_data_dict = {'non_na_x': non_na_x_, 
                            'non_na_y': non_na_y_, 
                            'x':    x_, 
                            'y':    y_, 
                            'x_range': x_range, 
                            'y_range': y_range,
                            'corr': correlation.toFixed(3),
                            'pv': corr_pv.toExponential(2).toString().replace(/e\+?/, ' x 10^')
                        }
    return return_data_dict
}